export default "__VITE_ASSET__DARJTzl8__"